module.exports = __webpack_public_path__ + "img/10logo.5cb3fe65.png";